import NavBar from '@modules/admin/Admin.Sidebar.NavBar'
import SidebarProfile from '@modules/admin/Admin.Sidebar.Profile'
import { getSelf } from '@modules/auth/auth.Dux'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import Consultations from '@services/Consultations'
import Customer from '@services/Customer'
import Professional from '@services/Professional'
import Marketing from '@services/Marketing'
import SelectI18nLanguage from '../i18n/SelectI18nLanguage'
import './Admin.scss'
import PageForbidden from './screens/PageForbidden'
import PageNotFound from './screens/PageNotFound'
import PageServerError from './screens/PageServerError'
import UnexpectedError from './screens/UnexpectedError'
import { refreshAdminDataTrigger } from './Admin.Dux'
import MSConsultations from '@/Services/MSConsultations'

class Admin extends Component {
  constructor(props) {
    super(props)

    Professional.updateHeaders({ Authorization: `Bearer ${props.self.jwtToken}` })
    Consultations.updateHeaders({ Authorization: `Bearer ${props.self.jwtToken}` })
    Customer.updateHeaders({ Authorization: `Bearer ${props.self.jwtToken}` })
    Marketing.updateHeaders({ Authorization: `Bearer ${props.self.jwtToken}` })
    MSConsultations.updateHeaders({ Authorization: `Bearer ${props.self.jwtToken}` })

    this.state = {
      error: null,
      codeError: '',
    }
  }

  static getDerivedStateFromError(error) {
    if (error.response) {
      return { error: error.message, codeError: error.response.status }
    }
    // Update state so the next render will show the fallback UI.
    return { error: error.message, codeError: 'runtime' }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      return this.setState({ error: null, codeError: null })
    }
  }

  componentDidMount() {
    const { self, i18n } = this.props
    Consultations.auth
      .updateLanguage({ admin_hash: self.profile.hash, language_code: i18n.language })
      .then(() => null)
      .catch((e) => console.log(e))
    this.props.dispatch(refreshAdminDataTrigger())
  }

  render() {
    const { self } = this.props
    const { error, codeError } = this.state

    return (
      <div className="dashboard">
        <div className="sidebar">
          <SelectI18nLanguage />
          <SidebarProfile />
          <NavBar user={self} />
        </div>

        <div className="dashboard-content">
          {
            {
              403: <PageForbidden />,
              404: <PageNotFound />,
              500: <PageServerError />,
              runtime: <UnexpectedError message={error} />,
            }[codeError]
          }
          {!error && this.props.children}
        </div>
      </div>
    )
  }
}

const mapStoreToProps = (store) => ({
  self: getSelf(store),
})

export default withTranslation()(compose(withRouter, connect(mapStoreToProps))(Admin))
